import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@nubank/nuds-web/components/Typography/Typography';

function Slide({ title, text }) {
  return (
    <div>
      <Typography tag="h2" variant="text1" gutterBottom={2}>
        {title}
      </Typography>
      <Typography color="primary" variant="title" tag="p">
        {text}
      </Typography>
    </div>
  );
}

Slide.propTypes = {
  text: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default Slide;
